import { Link } from "react-router-dom";

export function CrmImportStubPage() {
  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold text-slate-900 dark:text-white">CRM import</h1>
      <p className="max-w-2xl text-sm text-slate-600 dark:text-slate-400">
        Bulk CSV import for leads, accounts, and contacts matches the monolith import wizard. That flow is not ported in
        One yet; use the main dashboard import or wait for the next peel release.
      </p>
      <Link
        to="/crm/leads"
        className="inline-flex rounded-md border border-gray-300 px-3 py-2 text-sm font-semibold hover:bg-gray-50 dark:border-white/20 dark:hover:bg-white/10"
      >
        Back to leads
      </Link>
    </div>
  );
}

export function CrmUnknownRoutePage() {
  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold text-slate-900 dark:text-white">CRM module</h1>
      <p className="text-sm text-slate-600 dark:text-slate-400">
        This CRM path is not available in One yet. Use the sidebar modules or return to the CRM dashboard.
      </p>
      <Link
        to="/crm/overview"
        className="inline-flex rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white hover:bg-indigo-500"
      >
        CRM dashboard
      </Link>
    </div>
  );
}
